<template>
    <!-- Main Content -->
    <div>
        <div ref="newsfeeds" id="newsfeed-items-grid" class="">
            <timeline-review :signedIn="signedIn" ></timeline-review>
        </div>

    </div>
    <!-- ... end Main Content -->
</template>

<script>
    import jquery from "jquery";
    import timelineReview from "./timelineReview";

    var pageData = {
        moreFeeds: false,
        timelineReview: '',
        feedImages: "",
        withFixture: false,
        fullFeedsCount: "",
        formModelComment: {
            comment: "",
        },
        user_likes: "",
        signedIn: false,
        userData: '',
    };
    var $ = jquery;
    export default {
        name: "Newsfeeds",
        data() {
            return pageData;
        },
        props: ["fixtureId"],
        components: { timelineReview },
        watch: {
            // bottom(bottom) {
            //     if (bottom) {
            //         this.loadMorePost()
            //     }
            // }
        },
        created() {
            // window.addEventListener('scroll', () => {
            //     // this.bottom = this.bottomVisible()
            //     alert('fewkfmlemfkwef')
            // });
            // Inactive
            // window.addEventListener('blur', stopTimer);
        },
        methods: {
            getTime() {
                // function timeConverter(UNIX_timestamp){
                //   var a = new Date('1571794180' * 1000);
                //   var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                //   var year = a.getFullYear();
                //   var month = months[a.getMonth()];
                //   var date = a.getDate();
                //   var hour = a.getHours();
                //   var min = a.getMinutes();
                //   var sec = a.getSeconds();
                //   var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
                //   // var tm = jQuery.timeago(new Date(time));
                //   return jQuery(time).timeago();
                // }
                // // console.log(timeConverter(0));
            },
            getUserLikes(likes) {
                let likesHtml = '';
                var likes_count = likes.length;
                if (likes_count > 0 && likes_count === 1) {
                    likesHtml = `
          <a href="#">User</a>
          <br />liked this
        `;
                }else if(likes_count > 1 && likes_count === 3) {
                    likesHtml = `
          <a href="#">You</a>,
          <a href="#">Elaine</a> and
          <br />1 more liked this
        `;
                }else if (likes_count > 3) {
                    likesHtml = `
          <a href="#">You</a>,
          <a href="#">Elaine</a> and
          <br /> ${likes_count - 2} more liked this
        `;
                }else {
                    likesHtml = '';
                }
                // for (let i = 0; i < users.length; i++) {
                //   const element = users[i];
                //   console.log(element);
                // }
                // console.log(likes_count);
                return likesHtml;
            },
            // reset comment box
            checkUserData(userData) {
                if (userData !== "" || userData !== "undefined") {
                    this.userData = JSON.parse(userData);
                    this.signedIn = true;
                }
            },
            bottomVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const pageHeight = document.documentElement.scrollHeight
                const bottomOfPage = visible + scrollY >= pageHeight
                return bottomOfPage || pageHeight < visible
            },
            getMetaDataUrl(url) {
                // console.log(url);
                this.axios
                    .get(`https://api.urlmeta.org/?url=${url}`)
                    .then(response => {
                        // console.log(response);
                    })
                    .catch(error => {
                        // console.log(error);
                    })
            },
            loadMorePost() {
                var page_num = this.current_page;
                var max_pages = this.last_page;
                var next_link = this.next_page_url;
                var container = $("#newsfeed-items-grid");

                // console.log('max page', max_pages)
                // console.log('next link', next_link)

                this.axios
                    .get(`${next_link}`)
                    .then(response => {
                        const feeds = response.data.data.feeds.data;
                        const current_feeds = this.feeds;

                        this.feeds[0].push(feeds)

                        // this.feeds = feeds;
                        // this.fullFeedsCount = response.data.data.feeds_count;
                        // this.feedsStatus = response.data.data.status;
                        // this.next_page_url = response.data.data.feeds.next_page_url;
                        // this.last_page_url = response.data.data.feeds.last_page_url;
                        // this.first_page_url = response.data.data.feeds.first_page_url;
                        // this.current_page = response.data.data.feeds.from;
                        // this.last_page = response.data.data.feeds.to;

                        // var feeds = response.data.data.reviews.data;
                        // this.feeds.push(feeds);
                        // // this.feeds = feeds;
                        // this.next_page_url = response.data.data.reviews.next_page_url;
                        // this.last_page_url = response.data.data.reviews.last_page_url;
                        // this.first_page_url = response.data.data.reviews.first_page_url;
                        // this.current_page = response.data.data.reviews.from;
                        // this.last_page = response.data.data.reviews.to;
                    })
                    .catch(error => {
                        return error;
                        // console.log(error.response);
                    });
            },
        },
        mounted() {
            if (this.$props.fixtureId) {
                this.withFixture = true;
            } else {
                this.withFixture = false;
            }

            // $("title").html("Welcome to " + this.$store.state.projectName);

            this.getTime();
            var userData = localStorage.fansData;
            if (userData) {
                this.checkUserData(userData);
            }
        },
    };
</script>

<style>
    .ui-block-title {
        border-bottom: none;
    }
    .fw-1 {
        width: 100%;
    }
    .post-additional-info {
        border-top: none;
        padding: 0;
    }
    .blog-post .post-content {
        padding: 20px 0;
    }
</style>
